import { useCallback } from "react";
import { type Arguments, useSWRConfig } from "swr";

function checkMatch(searchPath: string, key: Arguments) {
  if (typeof key === "string") {
    return key.includes(searchPath);
  }
  // In previous versions of our useAPI hook we used an array of objects as a key.
  return (
    Array.isArray(key) &&
    key[0] &&
    typeof key[0] === "object" &&
    "path" in key[0] &&
    typeof key[0].path === "string" &&
    key[0].path.includes(searchPath)
  );
}

export function useRevalidatePaths() {
  const { mutate } = useSWRConfig();
  return useCallback(
    (searchPath: string | string[], awaitRevalidate: boolean = false) => {
      if (!awaitRevalidate) {
        return mutate(
          (key: Arguments) => {
            if (typeof searchPath === "string") {
              return checkMatch(searchPath, key);
            }
            return searchPath.some((path) => checkMatch(path, key));
          },
          (data: any) => data,
          { revalidate: true }
        );
      }
      const keys: Arguments[] = [];
      mutate((key: Arguments) => {
        const isMatch =
          typeof searchPath === "string"
            ? checkMatch(searchPath, key)
            : searchPath.some((path) => checkMatch(path, key));
        if (isMatch) {
          keys.push(key);
        }
        return false;
      });
      return Promise.allSettled(keys.map((key) => mutate(key)));
    },
    [mutate]
  );
}
